__turbopack_context__.v({
  "timeEntryTaskSelect": "A5uFQq_timeEntryTaskSelect",
  "timeEntryTaskSelect__empty": "A5uFQq_timeEntryTaskSelect__empty",
  "timeEntryTaskSelect__list": "A5uFQq_timeEntryTaskSelect__list",
  "timeEntryTaskSelect__meta": "A5uFQq_timeEntryTaskSelect__meta",
  "timeEntryTaskSelect__meters": "A5uFQq_timeEntryTaskSelect__meters",
  "timeEntryTaskSelect__option": "A5uFQq_timeEntryTaskSelect__option",
  "timeEntryTaskSelect__taskName": "A5uFQq_timeEntryTaskSelect__taskName",
  "timeEntryTaskSelect__title": "A5uFQq_timeEntryTaskSelect__title",
});
